import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { PencomRoutes } from "@/router/PencomRoutes";

export const ErrorPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(PencomRoutes.DASHBOARD);
    }
  };

  const handleGoHome = () => {
    navigate(PencomRoutes.DASHBOARD);
  };

  return (
    <div className="min-h-screen bg-off-white flex items-center justify-center px-4">
      <div className="max-w-[480px] w-full bg-white border border-stroke rounded-2xl px-8 py-10 shadow-sm flex flex-col items-center text-center gap-y-6">
        <img
          src="/assets/images/onboarding/pencom_logo_transparent.png"
          alt="PenCom"
          className="w-16 h-16 object-contain mb-2"
          loading="lazy"
        />
        <div className="flex flex-col gap-y-2">
          <h1 className="font-clash-display font-semibold text-[24px] text-medium-dark-grey tracking-[-0.4px]">
            Something went wrong
          </h1>
          <p className="font-clash-display text-sm text-medium-grey leading-[20px] tracking-[-0.06px]">
            The page you&apos;re looking for doesn&apos;t exist, or an unexpected
            error occurred. You can go back or return to your dashboard.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full mt-2">
          <PrimaryButton
            title="Go to Dashboard"
            className="w-full"
            onClick={handleGoHome}
          />
          <button
            type="button"
            onClick={handleGoBack}
            className="w-full border border-stroke rounded-lg h-[50px] flex items-center justify-center font-clash-display text-sm font-semibold text-medium-dark-grey bg-off-white hover:bg-[#EDEFF3] transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;

